import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tags-popover-content" }

import CardTag from '@/components/elements/CardTag';


export default /*@__PURE__*/_defineComponent({
  __name: 'TagsPopoverContent',
  props: {
    cardTags: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardTags, (tag) => {
      return (_openBlock(), _createBlock(_unref(CardTag), {
        ref_for: true,
        ref: "tagsWrap",
        key: tag.id,
        name: tag.name,
        "show-name": true,
        color: tag.color,
        tooltip: false
      }, null, 8, ["name", "color"]))
    }), 128))
  ]))
}
}

})